import React from 'react'
import { IonButton, IonButtons, IonContent, IonFooter, IonPage, IonToolbar, useIonViewWillLeave } from '@ionic/react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import PCRHeader from '../../../../components/pcrHeader/PCRHeader.component'
import HeaderNav from '../../../../components/headerNav/HeaderNav.component'
import { TabConstants } from '../../../../components/tabs/Tabs.constants'
import PainScalesSection from '../../painScaleSection/PainScalesSection.component'
import { checkQuickActionsRedirect, saveVitals, setPainScales } from '../../store/vitals.actions'
import { IRootState } from '../../../../store'
import { setScrollTargetID } from '../../../../components/scrollToTopButton/store/scrollToTop.actions'

const VitalsPainScalesPage: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()
  const { painPNNV, painScales } = useSelector((state: IRootState) => state.vitals)

  const navigateBackToVitals = () => {
    history.back()
  }

  const hasPainData = (painScales?.painScaleSelections?.length ?? 0) > 0 || Boolean(painScales?.totalsCombined)

  const handleClear = () => {
    dispatch(setPainScales({ totalsCombined: '', painScaleSelections: [] }))
  }

  useIonViewWillLeave(() => {
    if (history.location.pathname !== TabConstants.VITALS_TAB) {
      dispatch(checkQuickActionsRedirect())
    } else {
      dispatch(setScrollTargetID('painScaleButton'))
    }
  })

  return (
    <IonPage id='VitalsPainScalesPage'>
      <PCRHeader />
      <HeaderNav
        prevOnClick={navigateBackToVitals}
        prevLabel={t('common.buttons.Back')}
        title={t('vitals.painScale.title')}
        isBackButton={true}
      />
      <IonContent fullscreen color='light'>
        <PainScalesSection isDisabled={Boolean(painPNNV)} />
      </IonContent>
      <IonFooter>
        <IonToolbar color='light' className='p-10'>
          <IonButtons className='btn-grps'>
            <IonButton
              className='btn btn-tablet'
              color='danger'
              fill='outline'
              expand='block'
              disabled={!hasPainData}
              onClick={handleClear}>
              {t('common.buttons.Clear')}
            </IonButton>
            <IonButton
              className='btn btn-tablet btn-primary'
              expand='block'
              disabled={!hasPainData}
              onClick={() => {
                dispatch(saveVitals())
                navigateBackToVitals()
              }}>
              {t('common.buttons.Save')}
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonFooter>
    </IonPage>
  )
}

export default VitalsPainScalesPage
